import { ApiKeyConsentRequiredError } from '../../../providers/api-keys/api-keys-service';

export const CONSENT_MESSAGE =
  'This action needs additional consent. Please complete the attestation prompt and try again.';

/**
 * Map an API-key service error to a user-facing message. A consent gate
 * (ApiKeyConsentRequiredError) surfaces the friendly CONSENT_MESSAGE; any other
 * Error surfaces its own message; everything else falls back to `fallback`.
 *
 * Shared by the page (load/delete/sessions) and the create modal so all four
 * call paths render the consent gate identically.
 *
 * No app-wide attestation flow exists yet (grep: requires_consent -> 0 hits).
 * TODO(IM-2168): when the consent flow lands, route ApiKeyConsentRequiredError
 * into it instead of surfacing CONSENT_MESSAGE here.
 */
export const messageForError = (error: unknown, fallback: string): string => {
  if (error instanceof ApiKeyConsentRequiredError) {
    return CONSENT_MESSAGE;
  }
  return error instanceof Error ? error.message : fallback;
};
